import classNames from "classnames";

const Divider = (props: { className?: string }) => {
    const classes = classNames("h-[2px] bg-divider", props.className)
    return <hr className={classes} />;
}

export default Divider;